import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import Helpers from 'infosite/helpers';
import Notes from './notes';
import SlideIcons from './slide-icons';
import SlideStore from './slide-store';
import Reflux from 'reflux';

export default class SlideContent extends Reflux.Component {
  constructor(props){
    super(props);
    this.state = {};
    this.store = new SlideStore(props);
  }
  componentDidMount(){
    let $this = $(ReactDOM.findDOMNode(this));
    const callbacks = {
        ZoomImages: {
            onZoom: (e)=>{
                this.props.pause();
            }
        }
    }
    Helpers.loadCarouselModules($this[0],callbacks)
  }
  render() {
    const content = Utils.getDangerousHtml(this.props.html);


    const notes = $.extend({
      slideIndex: this.props.index,
      isActive: this.state.showNotes,
      SlideActions: this.props.SlideActions,
      Buttons: this.props.Buttons
    },this.props.notes);

    const containerProps = {
      className: `slide-content-container ${this.props.className}`,
      onClick: (e)=>{
          this.props.pause();
      }
    }
    if(this.props.label.length==0 && this.props.caption.length==0){
      return (
          <div {...containerProps}>
            <div className="content-wrapper">
              <div className="slide-content" dangerouslySetInnerHTML={content}></div>
            </div>
            <Notes {...notes} />
          </div>
      );
    }
    const label = Utils.getDangerousHtml(this.props.label);
    const caption = Utils.getDangerousHtml(this.props.caption);
    return (
        <div {...containerProps}>
          <div className="content-label-caption-wrapper">
            <div className="slide-content-flex">
              <div className="slide-content" dangerouslySetInnerHTML={content}></div>
            </div>
            <div className="label-caption-flex">
              <div className="label-caption-container">
                 <div className="slide-label" dangerouslySetInnerHTML={label}></div>
                 <div className="slide-caption" dangerouslySetInnerHTML={caption}></div>
              </div>
            </div>
          </div>
          <Notes {...notes} />
        </div>
    );
  }
}

SlideContent.propTypes={
    index: React.PropTypes.number,
    html: React.PropTypes.string,
    label: React.PropTypes.string,
    caption: React.PropTypes.string,
    className: React.PropTypes.string,
    notes: React.PropTypes.object,
    SlideActions: React.PropTypes.object,
    Buttons: React.PropTypes.object
}
SlideContent.defaultProps={
  html: '',
  label: '',
  caption: '',
  className: '',
  notes: {
    content: '',
    icon: ''
  }

}



// WEBPACK FOOTER //
// ./src/app/carousel/slide-content.jsx